<template>
  <div class="MyRes fs20">
    <div v-if="success" class="success">
      {{title['success']}}
    </div>
    <div v-else class="failed">
      {{title['failed']}}
    </div>
    <div class="detail">
      <div class="note fs18">
        <div class="content" v-if="success">
          <!-- <div>
               恭喜你从全国众多参赛选手中以前 5% 的优异成绩脱颖而出成功晋级““扣哒杯”人工智能大赛”全国总决赛。下图是你的完赛证书，点击图片可以下载。
               </div> -->
          <!-- </div>
               <div class="content" v-if="passed && !success"> -->
          <div>
            恭喜你从全国众多参赛选手中脱颖而出成功晋级““扣哒杯”人工智能大赛”全国总决赛。总决赛将于 12月18日（星期日）开始，敬请期待！
          </div>
        </div>

        <div class="content" v-else>
          <div>
            很遗憾你的成绩未晋级““扣哒杯”人工智能大赛”全国总决赛。感谢你的积极参与和一路陪伴，希望你明年再接再厉，向全国总决赛进军冲刺。
          </div>
        </div>
        <div class="badging">
          <div>
            大赛组委会
          </div>
          <div>
            2022年12月16日
          </div>
        </div>
        <!-- <div class="reward-image" v-if="passed" @click="download()">
             <canvas id="canvas" style="width: 50vw;" />
             </div> -->
      </div>
      <!-- <div class="info" v-if="user.realname">
           <div v-for="(v, k) in info" class="column">
           <div class="first_line">{{k}}</div>
           <div>{{v}}</div>
           </div>
           </div> -->
      <!--      <div v-else class="certify">-->
      <!--        <certify></certify>-->
      <!--      </div>-->

    </div>
  </div>
</template>

<script>
 import Certify from '@/components/score/Certify.vue'
 import MyImage from '@/components/Image.vue'
 import ProfImg from '@/assets/image/score/prof.png'
 import SealImg from '@/assets/image/score/aiyouth_seal.png'
  /* import SuccProfImg from '@/assets/image/score/succProf.jpg' */
 import qrImg from '@/assets/image/score/qrcode.jpeg'
 import finalPng from '@/assets/image/score/final.png'

 export default {
   name: 'Prelim',
   props: [],
   computed: {
     qr () {
       return qrImg
     },
     finalPng () {
       return finalPng
     },
     game_year() {
       return this.$store.state.game_slug.slice(0, 4)
     },
     passed () {
       return this.$store.state.auth.game_state[this.game_year+'-1'].state > 1
     },
     success () {
       return this.$store.state.auth.game_state[this.game_year+'-1'].state == 3
     },
     rewardImg() {
       return ProfImg
     },
     sealImg () {return SealImg;
     },
     user() {
       return this.$store.state.auth.user;

     },
     group() {
       return ['小学组', '初中组', '大学组']
     },
     info() {
       return {
         '姓名': this.user.realname,
         '身份证号': this.user.idcard,
         '地区': this.user.area,
         '组别': this.group[this.user.group-1],
         '参赛单位': this.user.organization? this.user.organization: '个人报名'
       }
     },
     username() {
       return this.user.realname || this.user.name
     },
     title() {
       return {
         'success': '恭喜你已成功晋级全国决赛',
         'failed':'很遗憾你没有晋级全国决赛'
       }
     },
     certificateUrl(){
       let redirect = `/certificates/${this.user.coco_id}?class=5d74782a64cd560026a803ab&course=560f1a9f22961295f9427742&course-instance=5d747ea564cd560026a80438`
       // let redirect = `/certificates/${this.user.coco_id}?class=5cb703db3546da005974ea29&course=560f1a9f22961295f9427742&course-instance=5cb703dbb42c5c004687cf29`
       // console.log("redirect", redirect)
       let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
       return url
     },
     ifPassedLevel(){
       return this.passed ? '你可以登陆至本次大赛竞赛平台领取你的美国大学理事会认证的' : '你可以继续完成竞技场前18个初赛学习关卡即可获得美国大学理事会认证的'
     },
   },
   data() {
     return {
       time: '11月20日',
       QQ: 'QQ群：926470859',
       reward: "计算机科学1级（CS1）证书"
     }
   },
   methods: {
     async download() {
       let can = document.getElementById("canvas")
       let blob = await new Promise(resolve=>can.toBlob(resolve));
       let url = URL.createObjectURL(blob);
       let a = document.createElement('a');
       a.href = url;
       a.download = '证书.png';
       a.click();
     },
     calcSN(rank) {
       let r = rank.toString()
       let len = 4-r.length;
       while(len > 0)
       {
         len -= 1;
         r = '0' + r;
       }
       return '2021' + (''+Math.random()).slice(2, 4) + r;
     }
   },
   components:{
     certify: Certify,
     my_image: MyImage
   },
   mounted()
   {
     // this.passed = !this.passed;
     let that = this;
     this.$http.get('/api/rank/me?round='+ this.game_year + '-1')
         .then(res => {
           return;
           let canvas = document.getElementById('canvas'),
               ctx = canvas.getContext('2d');
           let img = new Image();
           img.src = this.rewardImg;
           console.log(img)
           img.onload = () => {
             canvas.height = img.height;
             canvas.width = img.width;
             ctx.drawImage(img, 0, 0);
             ctx.font = "28pt Verdana";
             ctx.fillStyle = "black";
             ctx.fillText(this.username,80,290);
             ctx.fillStyle = "red";
             ctx.font = "12pt Verdana";
             ctx.fillText(this.calcSN(res.data.rank), 840, 116);
           let seal = new Image();
           seal.src = this.sealImg;
           seal.onload = () => {
             ctx.drawImage(seal, 800, 540);
           }
           }
         })
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .download{
   cursor: pointer;
 }
 .MyRes, .detail{
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content:center;
   position: relative;
   margin-bottom: 2vw;
 }
 .success, .failed{
   color: white;
   background-size: 60vw;
   width: 60vw;
   height: 10vw;
   display:flex;
   justify-content:center;
   align-items:center;
   font-size: 2.3vw;
 }
 .success{
   background-image: url(~@/assets/image/score/success.png);
 }
 .failed{
   background-image: url(~@/assets/image/score/failed.png);
 }
 .info{
   background-image: url(~@/assets/image/score/bg-myinfo.png);
   background-size: 62.3vw;
   width: 62.3vw;
   height: 10.78vw;
   color: white;

   margin-top:4vw;
   box-sizing: border-box;
   padding-left: 4.375vw;
   padding-right: 5.4vw;
   padding-top:1.15vw;
   padding-bottom: 3.125vw;
   display: flex;
 }
 .column{
   flex-grow: 1;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
   border-right: solid 1px #7ec5ff;
 }
 .column:last-child{
   border-right: none !important;
 }
 .column>div{
   height: 3.25vw;
   display:flex;
   justify-content:center;
   align-items:center;
 }
 .first_line{
   border-bottom: solid 1px #7EC5FF;
   width: 100%;
 }
 .certify{
   position: absolute;
   background-color: rgb(255, 255, 255);
   border-radius: 5px;
   box-sizing: border-box;
   padding: 6.3vw 5vw 1vw 2.6vw;
   box-shadow: 1px 1px 5px rgba(0,0,0,0.1);
   height: 100%;
 }
 .note .content span{
   color:#FE2121;
 }
 .note .name{
   color: #2F2E38;
   font-weight: 600;
 }
 .note .content{
   color: #585668;
 }
 .note .badging{
   color: #585668;
   align-self: flex-end;
 }
 .note{
   display: flex;
   flex-direction: column;
   align-items:flex-start;
   width: 46vw;
 }
 .reward-image{
   margin-top: 3vw;
   display:flex;
   align-items:center;
   flex-direction: column;
   color: #405aee;
 }

 .important{
   font-weight: bold;
   color: #405aee;
   display: flex;
   align-items: center;
   margin-top: 1em;
   flex-direction: column;
 }
 .content{
   text-indent: 2em;
 }

</style>
